import Vue from 'vue'
import Vuex from 'vuex'
import loading from './modules/loading'
import content from './modules/content'
import noLogin from './modules/no-login'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    loading,
    content,
    noLogin
  },
  strict: debug
})
